import {GET_CHAT, GET_CHAT_SUCCESS, ADD_OUTGOING_MESSAGE} from "../constants/Chat";

export const getChat = (grupoid) => {
  return {
    type: GET_CHAT,
    payload: grupoid
  };
};

export const getChatSuccess = (chat) => {
  return {
    type: GET_CHAT_SUCCESS,
    payload: chat
  };
};

export const addOutgoingMessage = (chatId, message) => ({
  type: ADD_OUTGOING_MESSAGE,
  chatId,
  message
});